module.exports = __webpack_public_path__ + "images/new-error-icon.svg";